// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Hleb Serafimovich <hleb.serafimovich@celadon.ae>

export const getLoader = state => state.ArrangeCollectionReducer.loader;
export const getStatus = state => state.ArrangeCollectionReducer.status;
export const getTradeCustomer1 = state => state.ArrangeCollectionReducer.tradeCustomer1;
export const getTradeCustomer2 = state => state.ArrangeCollectionReducer.tradeCustomer2;
export const getError = state => state.ArrangeCollectionReducer.error;
export const getIsButtonPressed = state => state.ArrangeCollectionReducer.isButtonPressed;
